import { PATHS } from '@/app/router/paths'
import { AuthLayout, AuthLegalFooter, RustWordmark } from './AuthLayout'
import { RegisterForm } from './AuthForms'

export default function CaregiverRegisterPage() {
  return (
    <AuthLayout backTo={PATHS.role} backLabel="Terug naar rolkeuze">
      <RustWordmark width={140} />
      <h1 className="auth-headline" style={{ fontSize: 26 }}>
        Begeleidersaccount aanmaken
      </h1>
      <p className="auth-subtitle">
        Maak een begeleidersaccount. Je koppelt cliënten pas nadat zij daarvoor toestemming geven.
      </p>
      <RegisterForm role="caregiver" />
      <AuthLegalFooter />
    </AuthLayout>
  )
}
